// ----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
// ----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import type { HeadlessItem } from "../../types";
import type { UseApiFetchOptions, UseApiFetchResponse } from "../../composables/useApiFetch";
import type { NitroFetchOptions } from "nitropack";
import type { Ref, MaybeRef } from "vue";
import {
    $apiFetch,
    computed,
    unref,
    useApiFetch,
    useFetchDependencies
} from "#imports";

export function useHeadlessResource () {

    /**
     * Locate an item in the CMS by route
     * @param route (optional) The route to look up
     * @return The matching headless item
     */
    function getByRoute(
        route?: MaybeRef<string | undefined>
    ) : UseApiFetchResponse<HeadlessItem> {
        const computedUrl = computed( () => {
          let url_ = "/api/headless/route?";

        const routeUnref = unref( route );
        if (routeUnref === null)
            throw new Error("The parameter 'route' cannot be null.");
        else if (routeUnref !== undefined)
            url_ += "route=" + encodeURIComponent("" + routeUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");
          return url_;
        } );

        let options_: UseApiFetchOptions<HeadlessItem> = {
            method: "GET",
            watch: [computedUrl]
        };

        return useApiFetch<HeadlessItem>( computedUrl, options_ );
    }

    return {
        getByRoute,
    }
}


export function $headlessResource () {

    const dependencies_ = useFetchDependencies();

    /**
     * Locate an item in the CMS by route
     * @param route (optional) The route to look up
     * @return The matching headless item
     */
    function getByRoute(
        route?: string | undefined
    ) {
        let url_ = "/api/headless/route?";

        const routeUnref = unref( route );
        if (routeUnref === null)
            throw new Error("The parameter 'route' cannot be null.");
        else if (routeUnref !== undefined)
            url_ += "route=" + encodeURIComponent("" + routeUnref) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: NitroFetchOptions<string> = {
            method: "GET",
        };

        return $apiFetch<HeadlessItem>( url_, options_, dependencies_ );
    }

    return {
        getByRoute,
    }
}